import {
  type IsoDate,
  Tag,
  type TagIntent,
} from '@omnipresentgroup/design-system';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import {
  InvoiceReportNetSuiteType,
  InvoiceReportStatus,
} from '@omnipresentgroup/types';

import { getOverdueDays, isOverdueDate } from './utils';

type Props = {
  status: InvoiceReportStatus;
  dueDate: IsoDate;
  type: InvoiceReportNetSuiteType;
};

export const InvoiceReportPaymentStatus = ({
  status,
  dueDate,
  type,
}: Props) => {
  let displayStatus = status?.valueOf() || '';
  let openStatusIntent: TagIntent = 'warning';

  const isOverdue = isOverdueDate(dueDate);
  if (
    type === InvoiceReportNetSuiteType.INVOICE &&
    status === InvoiceReportStatus.OPEN &&
    isOverdue
  ) {
    const overdueDays = getOverdueDays(dueDate);

    displayStatus = `${overdueDays} ${overdueDays === 1 ? 'day' : 'days'} overdue`;
    openStatusIntent = 'error';
  }

  const statusMap: Record<InvoiceReportStatus, TagIntent> = {
    [InvoiceReportStatus.PAID_IN_FULL]: 'success',
    [InvoiceReportStatus.FULLY_APPLIED]: 'info',
    [InvoiceReportStatus.OPEN]: openStatusIntent,
    [InvoiceReportStatus.DEPOSITED]: 'default',
    [InvoiceReportStatus.NOT_DEPOSITED]: 'default',
    [InvoiceReportStatus.VOIDED]: 'default',
  };

  const tagIntent = statusMap[status];

  return (
    <Tag id="inv-status" size="small" intent={tagIntent}>
      {toSentenceCase(displayStatus)}
    </Tag>
  );
};
